import {
    CORE_LOAD_MASTER_DATA_FIN_EDGES_REQUEST,
    CORE_LOAD_MASTER_DATA_FIN_EDGES_SUCCESS,
    CORE_LOAD_MASTER_DATA_FIN_EDGES_FAILURE,

    CORE_LOAD_MASTER_DATA_FIN_EDGE_REQUEST,
    CORE_LOAD_MASTER_DATA_FIN_EDGE_SUCCESS,
    CORE_LOAD_MASTER_DATA_FIN_EDGE_FAILURE,

} from '../../masterDataTypes'
import { REQUEST_STATE } from '../../types'

const requestState = REQUEST_STATE

export default {
    masterFinEdges: (state = requestState, action) => {
        switch (action.type) {
            case CORE_LOAD_MASTER_DATA_FIN_EDGES_REQUEST:
                return state
            case CORE_LOAD_MASTER_DATA_FIN_EDGES_SUCCESS:
                if (action.payload) {
                    const { result, datas } = action.payload
                    if (result && datas) {
                        return datas
                    } else return []
                } else {
                    return []
                }
            case CORE_LOAD_MASTER_DATA_FIN_EDGES_FAILURE:
                return []
            default:
                return state
        }
    },
    masterFinEdge: (state = requestState, action) => {
        switch (action.type) {
            case CORE_LOAD_MASTER_DATA_FIN_EDGE_REQUEST:
                return state
            case CORE_LOAD_MASTER_DATA_FIN_EDGE_SUCCESS:
                if (action.payload) {
                    const { result, data } = action.payload
                    if (result && data) {
                        return data
                    } else return {}
                } else {
                    return {}
                }
            case CORE_LOAD_MASTER_DATA_FIN_EDGE_FAILURE:
                return {}
            default:
                return state
        }
    },
}


// WEBPACK FOOTER //
// ./src/app/redux/reducers/masterDatas/finEdge.js